// Do not use 'scale' as for device size over 3000x3000, GE logo start disappearing

// Accessible outside of the class as global var
var appDashScalingFactor;

const textSizeAdjustCSS = document.createElement('style');
textSizeAdjustCSS.id = 'textSizeAdjust';
textSizeAdjustCSS.type = 'text/css';
document.head.appendChild(textSizeAdjustCSS);

const textSizeAdjust = function (zoom) {
  const textSizeAdjustValue = zoom * 95 + '%';
  textSizeAdjustCSS.innerHTML = '#app * { ' +
    '-webkit-text-size-adjust: ' + textSizeAdjustValue + ';' +
    '-moz-text-size-adjust:' + textSizeAdjustValue + ';' +
    '-ms-text-size-adjust: ' + textSizeAdjustValue + ';' +
    '}';

  /* -moz-text-size-adjust: auto; */
  /* -webkit-text-size-adjust: auto; */
  /* -ms-text-size-adjust: auto; */
};

const autofit = function () {
  const useZoom = true;

  const container = document.getElementById('container');

  // initial fixed width
  const minH = window.supportDeviceHeight;
  const minW = window.supportDeviceWidth;

  // var maxScale = 3;
  // var minScale = 0.3;

  // console.log( 'scaling - ' + minH + ":" + minW);

  const ratioH = window.innerHeight / minH;
  const ratioW = window.innerWidth / minW;

  const ratio = ratioH < ratioW ? ratioH : ratioW;
  appDashScalingFactor = ratio;
  // On web, production explorer page default.aspx
  // the app scales within 0.62 -> 1 only.
  // Only uncomment during webify
  // if (!isElectron) {
  //   ratio = ratio > 1 ? 1 : ratio;
  //   ratio = ratio < 0.62 ? 0.62 : ratio;
  // }

  if (useZoom) {
    // console.log("use zoom!")
    if (BrowserDetect.browser === 'Firefox') {
      container.style.transform = 'scale(' + ratio + ')';
      container.style.transformOrigin = 'left top';
    }
    container.style.zoom = ratio;
    // Only use for safari 
    // textSizeAdjust(ratio);
  } else {
    container.style.mozTransform = 'scale(' + ratio + ')';
    container.style.transform = 'scale(' + ratio + ')';
    container.style.transformOrigin = 'left top';
  }

  if (isElectron) {
    const th = ratio * minH;
    let margin = (window.innerHeight - th) / 2;
    margin = (1 / ratio) * margin;
    container.style.marginTop = margin+'px';
  }
};

window.addEventListener('resize', autofit);

// init autofit
autofit();



//////////////////
// WEBPACK FOOTER
// ./static/assets/js/scaling.js
// module id = 240
// module chunks = 1